import { isRouteErrorResponse, Link, useRouteError } from 'react-router';
import { LogoMark } from '@/ui/Logo';

export function RouteError() {
  const err = useRouteError();
  const msg = isRouteErrorResponse(err) ? `${err.status} ${err.statusText}` : err instanceof Error ? err.message : 'Something broke while rendering this page.';
  return (
    <div className="raydius-pages flex min-h-dvh flex-col items-center justify-center gap-4 px-6 text-center">
      <LogoMark size={36} />
      <h1 className="raydius-wordmark text-3xl text-fg">Lost the signal.</h1>
      <div className="max-w-md text-xs text-fg-3">{msg}</div>
      <Link to="/" className="text-sm text-accent hover:text-accent-hover">
        Return to center ↗
      </Link>
    </div>
  );
}
